<template>
<div>
    <!--loader-->
    <div class="vld-parent">
      <loading loader='bars' :active.sync="isLoading" :can-cancel="true" :is-full-page="isFullPage">
      </loading>
    </div>
    <!--loader-->
    <div class="outer-wrapper">
       <div class="container mb-5">
            <div class="row">
                <div class="col-md-12 header1">
                    <img src="img/know_membership.jpg" width="100%">
                </div>
            </div>
            <div class="row mt-2 dv-part2">
                <div class="col-7 mt-2">Membership Name</div>
                <div class="col-5 mt-2"><b>You're not Prime Member</b></div>
                <!-- <div class="col-7 mt-2">Membership Start Date:</div>
                <div class="col-5 mt-2"><b>{{membership_data['membership_purchased_date']}}</b></div>
                <div class="col-7 mt-2">Membership Valid Till:</div>
                <div class="col-5 mt-2"><b>{{membership_data['membership_validity_date']}}</b></div>
                <div class="col-7 mt-2">Your Savings Till Today:</div>
                <div class="col-5 mt-2"><b>{{membership_data['membership_savings']}}</b></div>
                <div class="col-7 mt-2">Membership Days Remaining:</div>
                <div class="col-5 mt-2"><b>{{membership_data['membership_remaining_days']}}</b></div>
                <div class="col-7 mt-2">Membership Days Validity:</div>
                <div class="col-5 mt-2"><b>{{membership_data['membership_valid_days']}}</b></div>
                <div class="col-7 mt-2">Membership Min. Discount %:</div>
                <div class="col-5 mt-2"><b>{{membership_data['membership_discount_percentage']}}</b></div> -->
                <div class="col-12 mt-2" align="center" v-if="cartButton"><button class="AddPrimeBtn"  v-on:click.prevent="addToCart()">Add Prime Membership in my cart</button></div>
                <div class="col-12 mt-2" align="center" v-else><button style="background-color:#ccc;border:none" class="AddPrimeBtn">Add Prime Membership in my cart</button></div>
                <div class="col-12 mt-2"></div>
            </div>
             <div class="row mt-2 faq">
                <div class="col-md-12">FAQ</div>
             </div>
            <div class="row" style="border: 1px solid #000">
                <div class="col-md-12 mt-2 faq-div">
                    <div v-for="(faq, index) in faqs" :key="index">
                        <a :href="'#faq-'+ index" data-toggle="collapse" class="faq-ques">{{index+1}}. {{faq.question}}&nbsp;<i class="fas fa-chevron-down" style="float:right;"></i></a>
                        <div :id="'faq-'+ index" class="collapse faq-ans">
                            <p>{{faq.answer}}</p>
                            <div><img style="height:auto;width:auto;" v-bind:src="faq['img_src']"></div>
                        </div>
                        <hr/>
                    </div>                   
                </div>               
            </div>
            <div class="row mt-2 faq">
                <div class="col-md-12">T&C</div>
            </div>
            <div class="row" style="border: 1px solid #000">
                <div class="col-md-12 mt-2" v-for ="(tnc,index) in tncs" :key="index">
                   <p class="pFaQ">{{index+1}}. {{tnc.tnc}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
   name: 'knowMembership',
   bodyClass: 'know-membership-page',
   data() {
      return {
         userId: 451,
         isLoading: true,
         isLoaded: false,
         isFullPage: true,
         membership_data: [],
         cartButton: 1,
         faqs: [],
         tncs: [],
         apiUrl: 'https://doodhvale.in/dv/',
     }
   },
   components: {
        Loading
  },
   created() {
         this.isLoading = true;
         this.getPageContents();
   },
   methods: {
      getPageContents() {
         var fullUrl = document.URL
         var mykey = fullUrl.split('?myKey=')
         this.userId = mykey[1]
         let params = new URLSearchParams();
         params.append('user_id', mykey[1])
         params.append('add_cart', 0);
         axios.post(this.apiUrl + 'doodhvale/api/web/v3/users/user-membership-info', params)
            .then(response => {
                if (response.data.status === '000000') {
                    this.membership_data = response.data.membership_data
                    this.faqs = response.data.membership_data.faq
                    this.tncs = response.data.membership_data.tnc
                    this.cartButton = response.data.button_enable
                    this.isLoading = false;
                }                    
            })
            .catch(e => {
            })
      },

  addToCart() {  
         this.isLoading = true;
         let params = new URLSearchParams();
         params.append('user_id', this.userId)
         params.append('add_cart', 1);
         axios.post(this.apiUrl + 'doodhvale/api/web/v3/users/user-membership-info', params)
            .then(response => {    
                if (response.data.status === '000000') {
                    this.membership_data = response.data.membership_data
                    this.faqs = response.data.membership_data.faq
                    this.tncs = response.data.membership_data.tnc
                    this.cartButton = response.data.button_enable
                    this.isLoading = false;
                    this.$swal({
                        customClass: {
                        popup: 'custom-swal-popup',
                        confirmButton: 'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
                        },
                        text: response.data.popup_message,
                        allowOutsideClick: false
                    })              
                }
            })
            .catch(e => {
            })

   }
}
}
</script>
<style>
.header1{
    background-color:#404040;
}
.dv-part2{
     border: 5px solid #404040;
}
.AddPrimeBtn{
     background-color:#404040;
     color: #fff;
     line-height: 28px;
     border-radius: 4px;
     font-size: 14px;
}
.pFaQ {
 line-height: 15px;
}
.faq{
     background-color: #404040;
     color: aliceblue;
     text-align: center;
     font-weight: bold;
     height: 30px;
     line-height: 30px;    
}

[aria-expanded="true"] i {
            -webkit-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            transform: rotate(180deg);
        }

.faq-ques,.faq-div a:focus, .faq-div a:hover{    
    text-decoration: none;
    color: #000;
    font-size: 14px;
}
 .faq-ans{margin:10px;}

</style>
